import moment from "moment";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

Vue.config.productionTip = false;

new Vue({
  router,
  moment,
  render: (h) => h(App),
}).$mount("#app");
